import { createHOC } from 'vue-hoc';
import { flowRight as compose } from 'lodash';

import withUser from '~lib/common/hoc/withUser';
import fetchOrgData from '~lib/common/utils/fetchOrgData';
import renameProps from '~lib/common/hoc/renameProps';

import dataView from '~lib/common/hoc/dataView';
import queries from '~lib/common/queries/Assignment';
import AssignmentEditor from './AssignmentEditor';

const options = {
  name: 'AssignmentEditorContainer',
  data() {
    return {
      state: {
        loading: false,
        orgData: {
          users: [],
          groups: [],
        },
      },
    };
  },
  created() {
    this.state.loading = true;
    fetchOrgData(this.user).then(
      result => {
        this.state.orgData = result;
      },
      error => {
        console.log(error);
      },
    ).then(() => {
        this.state.loading = false;
    });
  },
  props: {
    user: {
      type: Object,
    },
  },
};

const renderWith = {
  props: {
    user() {
      return this.user;
    },
    orgData() {
      return this.state.orgData;
    }
  },
};

const AssignmentListContainer = createHOC(AssignmentEditor, options, renderWith);

const enhance = compose(
  dataView({
    queries: {
      fetchById: queries.fetchById,
      save: queries.save,
    },
  }),
  renameProps({ itemData: 'assignment' }),
  withUser()
);

export default enhance(AssignmentListContainer);
